// The same rules as MekomeServer Models/TagRules.cs (a role is a tag of the type "role").
export const TAG_MAX_LENGTH = 100

export type TagError = 'tag_too_long' | 'tag_has_comma'

// An empty tag is not an error here: the form just does not add it.
export const getTagError = (tagName: string): TagError | undefined => {
  const trimmed = tagName.trim()
  if (trimmed.length > TAG_MAX_LENGTH) return 'tag_too_long'
  if (trimmed.includes(',')) return 'tag_has_comma'
  return undefined
}
